export default __webpack_public_path__ + "static/media/black_hammer.e74f5c19.png";